module.exports = class LiveshowChatTokens {
	static get muteUser() { return '@mute_user@'; }
	static get unmuteUser() { return '@unmute_user@'; }

	static get blockUser() { return '@block_user@'; }
	static get unblockUser() { return '@unblock_user@'; }

	static get publisherDisconnect() { return '@publisher_disconnected@'; }
	
	static get paidShowRequest() { return '@paidshow_request@'; }

	static get leavePrivate() { return '@leaveprivate@'; }

	static get prepareWebrtcTranslation() { return '@prepare_webrtc_translation@'; }
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/liveshow-chat-tokens/index.es.js